import React from 'react';
import { TelemetryContextProps } from './types';

const updateContext = () => {
  throw Error('No Provider');
};

export const createContext = <A, C>(actions: A, context?: C) => React.createContext<TelemetryContextProps<A, C>>({ actions, context, updateContext });
